import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      ocultarApp: true
    }
  },
  {
    path: '/clientes',
    name: 'Clientes_Listado',
    component: () => import('../views/Clientes/Listado.vue')
  }, {
    path: '/personas/nuevo/:tipo',
    name: 'Personas_Nuevo',
    component: () => import('../views/Personas/Nuevo.vue')
  },
  {
    path: '/personas/:id',
    name: 'Personas_Editar',
    component: () => import('../views/Personas/Editar.vue')
  },
  {
    path: '/proveedores',
    name: 'Proveedores_Listado',
    component: () => import('../views/Proveedores/Listado.vue')
  },
  {
    path: '/transportes',
    name: 'Transportes_Listado',
    component: () => import('../views/Transportes/Listado.vue')
  },
  {
    path: '/productos',
    name: 'Productos_Listado',
    component: () => import('../views/Productos/Listado.vue')
  },
  {
    path: '/productos/nuevo',
    name: 'Productos_Nuevo',
    component: () => import('../views/Productos/Nuevo.vue'),
    params: true
  }, {
    path: '/productos/:id',
    name: 'Productos_Editar',
    component: () => import('../views/Productos/Editar.vue')
  },
  {
    path: '/compras',
    name: 'Compras_Listado',
    component: () => import('../views/Compras/Listado.vue') 
  },
  {
    path: '/compras/nuevo',
    name: 'Compras_Nuevo',
    component: () => import('../views/Compras/Nuevo.vue'),
    params: true
  },
  {
    path: '/compras/:_id',
    name: 'Compras_Ver',
    component: () => import('../views/Compras/Ver.vue'),
  },
  { 
    path: '/mercaderias',
    name: 'Mercaderias_Listado',
    component: () => import('../views/Mercaderias/Listado.vue')
  },
  {
    path: '/mercaderias/nuevo',
    name: 'Mercaderias_Nuevo',
    component: () => import('../views/Mercaderias/Nuevo.vue'),
    params: true
  }, {
    path: '/mercaderias/baja',
    name: 'Mercaderias_Baja',
    component: () => import('../views/Mercaderias/Baja.vue')
  }, {
    path: '/mercaderias/:id',
    name: 'Mercaderias_Ver',
    component: () => import('../views/Mercaderias/Ver.vue')
  },
  {
    path: '/mercaderias/baja/:id',
    name: 'Mercaderias_Baja_Ver',
    component: () => import('../views/Mercaderias/Baja_Ver.vue')
  },
  {
    path: '/ventas',
    name: 'Ventas_Listado',
    component: () => import('../views/Ventas/Listado.vue')
  },
  {
    path: '/ventas/nuevo',
    name: 'Ventas_Nuevo',
    component: () => import('../views/Ventas/Nuevo.vue')
  }, {
    path: '/ventas/:id',
    name: 'Ventas_Ver',
    component: () => import('../views/Ventas/Ver.vue'),
    props: true
  },
  {
    path: '/informes',
    name: 'Informes_Generar',
    component: () => import('../views/Informes/Generar.vue')
  },
  {
    path: '/contabilidad',
    name: 'Contabilidad_Panel',
    component: () => import('../views/Contabilidad/Panel.vue')
  },
  {
    path: '/gastos/:id',
    name: 'Gastos_Ver',
    component: () => import('../views/Contabilidad/Gastos_Ver.vue')
  },
  {
    path: '/transferencias/:id',
    name: 'Transferencias_Ver',
    component: () => import('../views/Contabilidad/Transferencias_Ver.vue')
  },
  {
    path: '/ajustes',
    name: 'Ajustes',
    component: () => import('../views/Ajustes/Ajustes.vue')
  },
  {
    path: '/pedidos',
    name: 'Pedidos',
    component: () => import('../views/Pedidos/Listado.vue')
  },
  {
    path: '/pedido/:_id',
    name: 'Pedidos_Ver',
    component: () => import('../views/Pedidos/Ver.vue')
  },
  {
    path: '/arqueos/nuevo',
    name: 'Arqueos_Nuevo',
    component: () => import('../views/Arqueos/Nuevo.vue')
  },
  {
    path: '/arqueos',
    name: 'Arqueos_Listado',
    component: () => import('../views/Arqueos/Listado.vue')
  },
  {
    path: '/arqueos/:_id',
    name: 'Arqueos_Ver',
    component: () => import('../views/Arqueos/Ver.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router